<template>
  <!-- CONTENT -->
  <div
    :id="'screen'"
    :style="{opacity: opacity}"
  >
    <main
      class="scrollable container"
      :style="{paddingBottom: '20px'}"
    >
      <h2 :style="{marginBottom: '20px'}">Deposits</h2>

      <!-- Current deposits -->
      <section :style="{marginBottom: '30px'}">
        <span
          class="t14"
          :style="{marginBottom: '10px', display: 'block'}"
          >Current deposits</span
        >
        <ul>
          <li
            v-for="(deposit, index) in deposits"
            :key="deposit.id"
            class="row-center"
            :style="{
              backgroundColor: '#FFF7F2',
              borderRadius: '10px',
              paddingRight: '20px',
              paddingLeft: '14px',
              paddingTop: '14px',
              paddingBottom: '14px',
              marginBottom: index === deposits.length - 1 ? '0' : '6px',
            }"
            @click="deposit.route && $router.push(deposit.route)"
          >
            <component :is="deposit.icon" />
            <div :style="{marginLeft: '8px', marginRight: 'auto'}">
              <h6>{{ deposit.amount }} USD</h6>
              <span class="t12">{{ deposit.date }}</span>
            </div>
            <span
              class="t14"
              :style="{color: 'var(--main-color)', fontWeight: '600'}"
              >{{ deposit.title }}</span
            >
          </li>
        </ul>
      </section>

      <!-- Current moneyboxes -->
      <section :style="{marginBottom: '30px'}">
        <span
          class="t14"
          :style="{marginBottom: '10px', display: 'block'}"
          >Current moneyboxes</span
        >
        <ul>
          <li
            v-for="moneyBox in moneyBoxes"
            :key="moneyBox.id"
            class="row-center"
            :style="{
              backgroundColor: '#FFF7F2',
              borderRadius: '10px',
              paddingRight: '20px',
              paddingLeft: '14px',
              paddingTop: '14px',
              paddingBottom: '14px',
            }"
          >
            <component :is="moneyBox.icon" />
            <div :style="{marginLeft: '8px', width: '100%'}">
              <h6>{{ moneyBox.amount }} USD</h6>
              <div class="row-center-space-between">
                <span class="t14">{{ moneyBox.for }}</span>
                <span class="t14">Goal: {{ moneyBox.goal }}</span>
              </div>
            </div>
          </li>
        </ul>
      </section>

      <!-- Buttons -->
      <section>
        <div
          class="row-center"
          :style="{gap: '17px'}"
        >
          <Button
            :title="'+ Moneybox'"
            :color-schema="'secondary'"
            @click="$router.push(routes.OPEN_MONEYBOX)"
            :containerStyle="{width: '100%'}"
          />
          <Button
            :title="'+ Deposit'"
            :color-schema="'primary'"
            @click="$router.push(routes.OPEN_DEPOSIT)"
            :containerStyle="{width: '100%'}"
          />
        </div>
      </section>
    </main>
  </div>
</template>

<script setup>
import {routes} from '@/routes';
import {useOpacity} from '@/hooks';

import {Button} from '@/components';
import {DepositSvg} from '@/assets/svg';
import {MoneyBoxSvg} from '@/assets/svg';
import {DepositCheckSvg} from '@/assets/svg';

const opacity = useOpacity();

const deposits = [
  {
    id: 1,
    title: 'Withdrawal →',
    amount: '1 712.78',
    option: 'Withdrawal →',
    date: 'Jan 1 - Apr 1, 2023',
    icon: DepositCheckSvg,
    route: '',
  },
  {
    id: 2,
    title: 'Top - up  →',
    amount: '3 648.37',
    option: 'Top - up  →',
    date: 'Feb 1 - May 1, 2023',
    icon: DepositSvg,
    route: routes.TOP_UP_PAYMENT,
  },
];

const moneyBoxes = [
  {
    id: 1,
    amount: '650.37',
    name: 'Piggy Bank',
    goal: '1 200 USD',
    for: 'New iPhone Pro Max',
    icon: MoneyBoxSvg,
  },
];
</script>
